import { ITncRepository } from '../../ports/ITncRepository';
import { CaseClosureData } from '../../domain/entities';

export class CloseCaseUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string, closureData: CaseClosureData): Promise<void> {
    return this.tncRepository.closeCase(caseId, closureData);
  }
}
